
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
		base: '#C3271A',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#4caf50',
      darken1: colors.purple.darken2,
  },
	warning: {
			base: '#ff9800',
      darken1: colors.purple.darken2,
	},
  hwsecondary: '#B9CADD',
  anchor: '#1976d2',
  humanwaytitle: '#0099CC',
  light: '#FEFEFE'
}